import React from 'react';

import View from './View';

const Edit = () => {
  return <View />;
};

export default Edit;
